import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { Benefits } from '../components/Benefits';
import { Services } from '../components/Services';
import { Testimonials } from '../components/Testimonials';
import { HowToJoin } from '../components/HowToJoin';
import { Contact } from '../components/Contact';
import { Footer } from '../components/Footer';
import { MobileCTABar } from '../components/MobileCTABar';

export const Home = () => {
  const location = useLocation();

  // Si se llega con /#seccion (por ejemplo desde /socios), bajar a esa sección
  useEffect(() => {
    if (!location.hash) return;
    const id = location.hash.slice(1);
    const t = setTimeout(() => document.getElementById(id)?.scrollIntoView({ behavior: 'smooth', block: 'start' }), 150);
    return () => clearTimeout(t);
  }, [location]);

  return (
    <div className="min-h-screen pb-20 lg:pb-0">
      <Header />
      <main id="contenido-principal" tabIndex={-1} className="focus:outline-none">
        <Hero />
        <Benefits />
        <Services />
        <Testimonials />
        <HowToJoin />
        <Contact />
      </main>
      <Footer />
      <MobileCTABar />
    </div>
  );
};
